import { Box } from '@mui/material'
import Fields from '../../Common/Fields'
import { useAppDispatch, useAppSelector } from '../../../redux/hook'
import {
    EntityStep,
    updateEntitySteps,
} from '../../../redux/slices/entityInstanceSlice'
import {
    BUSINESS_RULES_FIELD_ID,
    EntityStepTypes,
} from '../../../constants/constants'
import { ReactElement, useEffect, useRef } from 'react'

interface AttributeStepProps {
    onClickMap?: (val: boolean) => void
}

const AttributeStep = (props: AttributeStepProps): ReactElement => {
    const { onClickMap } = props
    const dispatch = useAppDispatch()

    const isFirstRun = useRef(true)

    const orgId = useAppSelector(
        (state) => state.entityInstance.startStep.orgId,
    )

    const path = useAppSelector((state) => state.entityInstance.path)

    const entitySteps = useAppSelector(
        (state) => state.entityInstance.entitySteps,
    )
    const activeEntityStep = useAppSelector(
        (state) => state.entityInstance.activeEntityStep,
    )

    const IsInstanceReadOnly = useAppSelector(
        (state) => state.entityInstance.readOnly,
    )

    useEffect(() => {
        if (path?.length > 1 && entitySteps?.length && isFirstRun.current) {
            let updateEntityStepsData = [...entitySteps]

            const parentValues: any = path[path.length - 1].parentValues
            updateEntityStepsData = updateEntityStepsData.map(
                (step: EntityStep) => {
                    if (
                        step.stepType === EntityStepTypes.Attributes &&
                        !step.instanceId
                    ) {
                        let updateAttributes = step.attributes?.length
                            ? [...step.attributes]
                            : []
                        updateAttributes = updateAttributes?.map((i) => {
                            if (
                                parentValues[i.id] &&
                                i.id.toLowerCase() !== 'id' &&
                                i.id.toLowerCase() !== BUSINESS_RULES_FIELD_ID
                            ) {
                                return {
                                    ...i,
                                    ...{ value: parentValues[i.id] },
                                }
                            } else {
                                return { ...i }
                            }
                        })

                        return { ...step, ...{ attributes: updateAttributes } }
                    } else {
                        return { ...step }
                    }
                },
            )
            isFirstRun.current = false
            dispatch(updateEntitySteps(updateEntityStepsData))
        }
    }, [path])

    const onChangeFields = (
        id: string,
        value: any,
        key?: string,
        otherId?: string,
        otherValue?: any,
        otherKey?: string,
    ) => {
        let updateSteps = [...entitySteps] // Create a copy of the steps array
        updateSteps = updateSteps.map((step: EntityStep) => {
            if (step.stepNo - 1 === activeEntityStep) {
                const updateFields = step.attributes?.map((i: any) => {
                    if (i.id === id) {
                        const obj = { ...i }
                        obj[key ?? 'value'] = value
                        obj['errorMessage'] = ''
                        return obj // Update the field value within the step
                    } else if (otherId && i.id === otherId) {
                        const obj = { ...i }
                        obj[otherKey ?? 'value'] = otherValue
                        obj['errorMessage'] = ''
                        return obj
                    } else {
                        return i
                    }
                })
                return { ...step, attributes: updateFields } // Update the step object with the updated fields
            }
            return step
        })
        dispatch(updateEntitySteps(updateSteps))
    }

    return (
        <Box>
            {/* <Box
                sx={{
                    marginBottom: '10px',
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: 1.43,
                    }}
                >
                    {entitySteps[activeEntityStep]?.attributes?.length
                        ? entitySteps[activeEntityStep]?.templateName
                        : ''}
                </Typography>
            </Box> */}
            <Box
                display="flex"
                flexWrap="wrap"
                alignItems="flex-start"
                justifyContent="flex-start"
            >
                <Fields
                    fields={entitySteps[activeEntityStep]?.attributes}
                    onChangeFields={onChangeFields}
                    onClickMap={onClickMap}
                    disabled={
                        entitySteps[activeEntityStep]?.readOnly ||
                        IsInstanceReadOnly
                    }
                    orgId={orgId}
                />
            </Box>
        </Box>
    )
}
export default AttributeStep
